import template from './loanRedirect.html';
import controller from './loanRedirectCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
